import {X_TAXI} from '../consts'
import type {SuggestRepository, SuggestRepositoryParameters} from './types'

export function createSuggestRepository(parameters: SuggestRepositoryParameters): SuggestRepository {
  const {fetch} = parameters

  return {
    fetchSuggest(body) {
      return fetch({
        headers: {
          [X_TAXI]: 'yandex.delivery',
        },
        url: 'phoenix/v2/suggest',
        method: 'POST',
        body,
      })
    },
  }
}
